/* ============================ Helpers ============================ */
async function API(url, method = "GET", body = null) {
  const res = await fetch(url, {
    method,
    headers: { "Content-Type": "application/json" },
    body: body ? JSON.stringify(body) : undefined,
  });
  let data = null;
  try {
    data = await res.json();
  } catch {}
  if (!res.ok) {
    const msg = (data && (data.error || data.message)) || res.statusText;
    throw new Error(`${method} ${url} failed: ${res.status} ${msg}`);
  }
  return data;
}

const HIST_DEBUG = true;

/* ===================== Bottom Expand/Collapse for Lesson Rail ===================== */

(function attachBottomRailToggle() {
  if (!window.Historian) {
    document.addEventListener("DOMContentLoaded", attachBottomRailToggle, {
      once: true,
    });
    return;
  }

  const STORE = "hist-rail-collapsed"; // default expanded -> false

  const isCollapsed = () => {
    try {
      return JSON.parse(localStorage.getItem(STORE) || "false");
    } catch {
      return false;
    }
  };
  const setCollapsed = (v) => {
    try {
      localStorage.setItem(STORE, JSON.stringify(!!v));
    } catch {}
  };

  function getLessonGrid() {
    const container = document.getElementById("historian-container");
    if (!container || !container.classList.contains("hist-lesson")) return null;
    let grid = container.querySelector("#lesson-grid");
    if (!grid) {
      const maybe = container.querySelector(".hist-grid.hist-grid--wide");
      if (maybe) {
        maybe.id = "lesson-grid";
        grid = maybe;
      }
    }
    return grid;
  }
  function getLessonRail() {
    const grid = getLessonGrid();
    if (!grid) return null;
    const rail = grid.querySelector(".hist-rail");
    if (rail && !rail.dataset.rail) rail.dataset.rail = "lesson";
    return rail;
  }

  function applyState(collapsed) {
    const grid = getLessonGrid();
    const rail = getLessonRail();
    if (grid) grid.classList.toggle("rail-collapsed", collapsed);
    if (rail) rail.classList.toggle("hist-rail--collapsed", collapsed);

    const btn = rail && rail.querySelector("#rail-toggle-bottom");
    if (btn) {
      btn.setAttribute("aria-expanded", (!collapsed).toString());
      btn.dataset.state = collapsed ? "collapsed" : "expanded";
    }
  }

  function ensureBottomButton() {
    const rail = getLessonRail();
    if (!rail) return false;
    if (rail.querySelector("#rail-toggle-bottom")) return true;

    const btn = document.createElement("button");
    btn.id = "rail-toggle-bottom";
    btn.type = "button";
    btn.className = "rail-toggle-bottom";
    btn.setAttribute("aria-label", "Toggle subtopics");
    btn.innerHTML = `
      <span class="chev" aria-hidden="true">❯</span>
      <span class="txt">Collapse</span>
    `;
    btn.addEventListener("click", () => {
      const next = !isCollapsed();
      setCollapsed(next);
      applyState(next);
    });

    rail.classList.add("rail-with-bottom-toggle");
    rail.appendChild(btn);

    // Default expanded
    applyState(false);
    return true;
  }

  // Hook after lesson render
  const _origLoadLesson = window.Historian?.loadLesson?.bind(window.Historian);
  if (_origLoadLesson) {
    window.Historian.loadLesson = async function (index) {
      const out = await _origLoadLesson(index);
      ensureBottomButton();
      return out;
    };
  }

  // Keep toggle after responsive rebuilds
  const _origApply = window.Historian?.applyResponsiveMode?.bind(
    window.Historian,
  );
  if (_origApply) {
    window.Historian.applyResponsiveMode = function () {
      const out = _origApply();
      setTimeout(ensureBottomButton, 0);
      return out;
    };
  }

  document.addEventListener("DOMContentLoaded", () =>
    setTimeout(ensureBottomButton, 0),
  );
})();

/* ===================== Bottom Expand/Collapse for Lesson Rail ===================== */

/* ===== Session ID (stable per browser tab) ===== */
function getHistSessionId() {
  const KEY = "hist-session-id";
  try {
    let id = sessionStorage.getItem(KEY);
    if (!id) {
      id =
        crypto && crypto.randomUUID
          ? crypto.randomUUID()
          : Date.now().toString(36) + Math.random().toString(36).slice(2, 10);
      sessionStorage.setItem(KEY, id);
    }
    return id;
  } catch {
    return Date.now().toString(36) + Math.random().toString(36).slice(2, 10);
  }
}
const HIST_SESSION_ID = getHistSessionId();

/* ============= Entry Button + Placeholders (auto-inject) ============= */
function ensurePlaceholders() {
  const ids = ["hist-topic", "hist-subtopics", "hist-lesson", "hist-quiz"];
  ids.forEach((id) => {
    if (!document.getElementById(id)) {
      const s = document.createElement("section");
      s.id = id;
      document.body.appendChild(s);
    }
  });
}

function ensureEntryButton() {
  let btn = document.getElementById("open-legend-hub");
  if (btn) {
    if (!btn.__histWired) {
      btn.addEventListener("click", () => {
        if (typeof window.openLessonHub === "function") {
          window.openLessonHub();
        } else {
          document.body.classList.add("lesson-hub-active");
          window.Historian.openHub();
        }
      });
      btn.__histWired = true;
    }
    return;
  }
  const wrap = document.createElement("div");
  wrap.id = "hist-entry-wrap";
  wrap.style.position = "fixed";
  wrap.style.bottom = "16px";
  wrap.style.right = "var(--hist-side-gutter, 24px)";
  wrap.style.zIndex = "9997";

  btn = document.createElement("button");
  btn.id = "open-legend-hub";
  btn.className = "hist-btn";
  btn.type = "button";
  btn.textContent = "📚 Explore Historical Legends";
  btn.addEventListener("click", () => {
    if (typeof window.openLessonHub === "function") {
      window.openLessonHub();
    } else {
      document.body.classList.add("lesson-hub-active");
      window.Historian.openHub();
    }
  });
  btn.__histWired = true;

  wrap.appendChild(btn);
  document.body.appendChild(wrap);
}

(function () {
  const start = () => {
    ensurePlaceholders();
  };
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start, { once: true });
  } else {
    start();
  }
})();

/* Optional debug wrapper */
(function () {
  const originalAPI = window.API || API;
  if (typeof originalAPI !== "function") return;
  window.API = async function (url, method = "GET", body = null) {
    const grp = `%c[API] ${method} ${url}`;
    console.groupCollapsed(grp, "color:#8ab4f8");
    try {
      if (body) console.log("→ body", body);
      const res = await fetch(url, {
        method,
        headers: { "Content-Type": "application/json" },
        body: body ? JSON.stringify(body) : undefined,
      });
      console.log("← status", res.status);
      let json = null;
      try {
        json = await res.json();
      } catch (e) {
        console.warn("← JSON parse failed", e);
      }
      console.log("← json", json);
      if (!res.ok) throw new Error(`${method} ${url} failed: ${res.status}`);
      return json;
    } catch (e) {
      console.error("API error:", e);
      throw e;
    } finally {
      console.groupEnd(grp);
    }
  };
})();

(function bindResizeOnce() {
  if (window.__histResizeBound) return;
  window.__histResizeBound = true;
  window.addEventListener(
    "resize",
    () => {
      if (
        window.Historian &&
        typeof window.Historian.applyResponsiveMode === "function"
      ) {
        window.Historian.applyResponsiveMode();
      }
    },
    { passive: true },
  );
})();

/* ============= Markdown + KaTeX ============= */
(function () {
  function loadStyle(href) {
    return new Promise((resolve, reject) => {
      const el = document.createElement("link");
      el.rel = "stylesheet";
      el.href = href;
      el.onload = resolve;
      el.onerror = () => reject(new Error("Style failed: " + href));
      document.head.appendChild(el);
    });
  }
  function loadScript(src) {
    return new Promise((resolve, reject) => {
      const s = document.createElement("script");
      s.src = src;
      s.async = true;
      s.onload = resolve;
      s.onerror = () => reject(new Error("Script failed: " + src));
      document.head.appendChild(s);
    });
  }

  const basicFallback = {
    render: (s) =>
      (String(s) || "")
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/\*\*(.+?)\*\*/g, "<strong>$1</strong>")
        .replace(/\*(.+?)\*/g, "<em>$1</em>")
        .replace(/`([^`]+?)`/g, "<code>$1</code>")
        .replace(/^###### (.*)$/gm, "<h6>$1</h6>")
        .replace(/^##### (.*)$/gm, "<h5>$1</h5>")
        .replace(/^#### (.*)$/gm, "<h4>$1</h4>")
        .replace(/^### (.*)$/gm, "<h3>$1</h3>")
        .replace(/^## (.*)$/gm, "<h2>$1</h2>")
        .replace(/^# (.*)$/gm, "<h1>$1</h1>")
        .replace(/^\s*---\s*$/gm, "<hr>")
        .replace(/\n{2,}/g, "</p><p>")
        .replace(/^/, "<p>")
        .replace(/$/, "</p>"),
  };

  let mdRenderer = basicFallback;
  let mdReady = false;

  const PH = {
    M_OPEN: "\uE000",
    M_CLOSE: "\uE001",
    C_OPEN: "\uE010",
    C_CLOSE: "\uE011",
  };
  const CDN = {
    katexCSS: [
      "https://cdn.jsdelivr.net/npm/katex@0.16.11/dist/katex.min.css",
      "https://unpkg.com/katex@0.16.11/dist/katex.min.css",
    ],
    katexJS: [
      "https://cdn.jsdelivr.net/npm/katex@0.16.11/dist/katex.min.js",
      "https://unpkg.com/katex@0.16.11/dist/katex.min.js",
    ],
    mdi: [
      "https://cdn.jsdelivr.net/npm/markdown-it@14.1.0/dist/markdown-it.min.js",
      "https://unpkg.com/markdown-it@14.1.0/dist/markdown-it.min.js",
    ],
  };

  async function tryLoad(urls, loader) {
    let lastErr;
    for (const u of urls) {
      try {
        await loader(u);
        return true;
      } catch (e) {
        lastErr = e;
        console.warn("[markdown] load failed:", u, e);
      }
    }
    if (lastErr) throw lastErr;
  }

  function protectCodeSegments(src) {
    const stash = [];
    src = src.replace(/```([\s\S]*?)```/g, (m) => {
      const id = stash.push(m) - 1;
      return `${PH.C_OPEN}${id}${PH.C_CLOSE}`;
    });
    src = src.replace(/`([^`]*?)`/g, (m) => {
      const id = stash.push(m) - 1;
      return `${PH.C_OPEN}${id}${PH.C_CLOSE}`;
    });
    return {
      text: src,
      restore: (s) =>
        s.replace(
          new RegExp(`${PH.C_OPEN}(\\d+)${PH.C_CLOSE}`, "g"),
          (_, i) => stash[Number(i)],
        ),
    };
  }

  function extractMathPlaceholders(src) {
    if (!window.katex) return { text: src, restore: (s) => s };
    const stash = [];
    const normalizeMathBody = (body) => {
      return body
        .replace(/\\\\([a-zA-Z])/g, "\\$1")
        .replace(/\\\\{/g, "\\{")
        .replace(/\\\\}/g, "\\}")
        .replace(/\\\\,/g, "\\,")
        .trim();
    };
    src = src.replace(
      /(^|[\n\s])\$\$([\s\S]+?)\$\$(?=$|[\n\s])/g,
      (m, pre, body) => {
        const normalized = normalizeMathBody(body);
        const html = window.katex.renderToString(normalized, {
          displayMode: true,
          throwOnError: false,
        });
        const id = stash.push(html) - 1;
        return `${pre}${PH.M_OPEN}${id}${PH.M_CLOSE}`;
      },
    );
    src = src.replace(/\$(?!\s)([^$\n]+?)\$(?!\s)/g, (m, body) => {
      const normalized = normalizeMathBody(body);
      const html = window.katex.renderToString(normalized, {
        displayMode: false,
        throwOnError: false,
      });
      const id = stash.push(html) - 1;
      return `${PH.M_OPEN}${id}${PH.M_CLOSE}`;
    });
    const restore = (html) =>
      html.replace(
        new RegExp(`${PH.M_OPEN}(\\d+)${PH.M_CLOSE}`, "g"),
        (_, i) => stash[Number(i)] || "",
      );
    return { text: src, restore };
  }

  function renderWithMarkdownIt(md, src) {
    const code = protectCodeSegments(src);
    const math = extractMathPlaceholders(code.text);
    const preMd = code.restore(math.text);
    let html = md.render(preMd || "");
    html = math.restore(html);
    return html;
  }

  async function initMd() {
    try {
      await tryLoad(CDN.katexCSS, loadStyle);
      await tryLoad(CDN.katexJS, loadScript);
    } catch {
      /* optional */
    }
    await tryLoad(CDN.mdi, loadScript);
    if (!window.markdownit) throw new Error("markdown-it missing");
    const md = window.markdownit({
      html: false,
      breaks: true,
      linkify: true,
      typographer: false,
    });
    mdRenderer = { render: (src) => renderWithMarkdownIt(md, src) };
    mdReady = true;
  }

  const readyPromise = (async () => {
    try {
      await initMd();
    } catch (e) {
      mdRenderer = basicFallback;
    }
  })();

  window.renderMarkdownSync = function (mdText) {
    try {
      return mdRenderer.render(mdText || "");
    } catch {
      return basicFallback.render(mdText || "");
    }
  };
  window.renderMarkdownAsync = async function (mdText, timeoutMs = 7000) {
    let timedOut = false;
    await Promise.race([
      readyPromise,
      new Promise((r) =>
        setTimeout(() => {
          timedOut = true;
          r();
        }, timeoutMs),
      ),
    ]);
    return window.renderMarkdownSync(mdText);
  };
  window.__mdReady = () => readyPromise.then(() => mdReady);
})();

/* =================== UI Utilities & Sheet =================== */
function escapeHtml(s) {
  return (s || "").replace(
    /[&<>\"']/g,
    (m) =>
      ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" })[
        m
      ],
  );
}
/* Skeleton loading templates */
function getSkeletonTopics() {
  return `
    <div class="hist-skeleton-container">
      <div class="hist-skeleton-header">
        <div class="hist-skeleton-status">
          <span class="hist-skeleton-dot"></span>
          <span class="hist-skeleton-dot"></span>
          <span class="hist-skeleton-dot"></span>
          <span>Finding great topics…</span>
        </div>
      </div>
      <div class="skeleton-card">
        <div class="skeleton skeleton-title"></div>
        <div class="skeleton-topic-grid">
          <div class="skeleton skeleton-chip"></div>
          <div class="skeleton skeleton-chip"></div>
          <div class="skeleton skeleton-chip"></div>
          <div class="skeleton skeleton-chip"></div>
          <div class="skeleton skeleton-chip"></div>
          <div class="skeleton skeleton-chip"></div>
        </div>
      </div>
      <div class="skeleton-card">
        <div class="skeleton skeleton-title"></div>
        <div class="skeleton-topic-grid">
          <div class="skeleton skeleton-chip"></div>
          <div class="skeleton skeleton-chip"></div>
          <div class="skeleton skeleton-chip"></div>
          <div class="skeleton skeleton-chip"></div>
        </div>
      </div>
    </div>`;
}

function getSkeletonLesson() {
  return `
    <div class="hist-skeleton-container">
      <div class="hist-skeleton-header">
        <div class="hist-skeleton-status">
          <span class="hist-skeleton-dot"></span>
          <span class="hist-skeleton-dot"></span>
          <span class="hist-skeleton-dot"></span>
          <span>Preparing lesson…</span>
        </div>
      </div>
      <div class="skeleton-lesson-layout">
        <div class="skeleton-lesson-main">
          <div class="skeleton-card">
            <div class="skeleton skeleton-title"></div>
            <div class="skeleton skeleton-subtitle"></div>
            <div class="skeleton-content-block">
              <div class="skeleton-paragraph">
                <div class="skeleton skeleton-text full"></div>
                <div class="skeleton skeleton-text long"></div>
                <div class="skeleton skeleton-text medium"></div>
              </div>
              <div class="skeleton-paragraph">
                <div class="skeleton skeleton-text full"></div>
                <div class="skeleton skeleton-text long"></div>
                <div class="skeleton skeleton-text short"></div>
              </div>
            </div>
          </div>
          <div class="skeleton-media">
            <div class="skeleton-media-icon"></div>
          </div>
          <div class="skeleton-card">
            <div class="skeleton-paragraph">
              <div class="skeleton skeleton-text long"></div>
              <div class="skeleton skeleton-text full"></div>
              <div class="skeleton skeleton-text medium"></div>
            </div>
          </div>
        </div>
      </div>
    </div>`;
}

function getSkeletonRetry(attempt, maxRetries) {
  return `
    <div class="hist-skeleton-container">
      <div class="hist-skeleton-header">
        <div class="hist-skeleton-status">
          <span class="hist-skeleton-dot"></span>
          <span class="hist-skeleton-dot"></span>
          <span class="hist-skeleton-dot"></span>
          <span>Retrying… (attempt ${attempt}/${maxRetries})</span>
        </div>
      </div>
      <div class="skeleton-card">
        <div class="skeleton skeleton-title"></div>
        <div class="skeleton-topic-grid">
          <div class="skeleton skeleton-chip"></div>
          <div class="skeleton skeleton-chip"></div>
          <div class="skeleton skeleton-chip"></div>
        </div>
      </div>
    </div>`;
}

function showLoading(el, text = "Preparing wisdom…", context = "default") {
  if (
    text.toLowerCase().includes("finding") ||
    text.toLowerCase().includes("topic") ||
    context === "topics"
  ) {
    el.innerHTML = getSkeletonTopics();
  } else if (
    text.toLowerCase().includes("preparing lesson") ||
    text.toLowerCase().includes("lesson") ||
    context === "lesson"
  ) {
    el.innerHTML = getSkeletonLesson();
  } else if (text.toLowerCase().includes("retry")) {
    const match = text.match(/attempt (\d+)\/(\d+)/i);
    if (match) {
      el.innerHTML = getSkeletonRetry(match[1], match[2]);
    } else {
      el.innerHTML = getSkeletonRetry("?", "?");
    }
  } else {
    el.innerHTML = `
      <div class="hist-skeleton-container">
        <div class="hist-skeleton-header">
          <div class="hist-skeleton-status">
            <span class="hist-skeleton-dot"></span>
            <span class="hist-skeleton-dot"></span>
            <span class="hist-skeleton-dot"></span>
            <span>${escapeHtml(text)}</span>
          </div>
        </div>
        <div class="skeleton-card">
          <div class="skeleton skeleton-title"></div>
          <div class="skeleton-content-block">
            <div class="skeleton skeleton-text long"></div>
            <div class="skeleton skeleton-text medium"></div>
          </div>
        </div>
      </div>`;
  }
}
function normalizeToEmbed(url) {
  try {
    const u = new URL(url, location.origin);
    if (u.hostname === "youtu.be") {
      const id = u.pathname.slice(1).split("?")[0];
      return id ? `https://www.youtube.com/embed/${id}` : url;
    }
    if (u.hostname.includes("youtube.com")) {
      if (u.pathname === "/watch") {
        const id = u.searchParams.get("v");
        if (id) return `https://www.youtube.com/embed/${id}`;
      }
      if (u.pathname.startsWith("/shorts/")) {
        const id = u.pathname.split("/")[2];
        if (id) return `https://www.youtube.com/embed/${id}`;
      }
      if (u.pathname.startsWith("/embed/")) return u.href;
    }
    return url;
  } catch {
    return url;
  }
}

/* Small inline spinner HTML for buttons */
function buttonSpinner(label = "Generating…") {
  return `<span class="hist-btn-spinner"></span>${escapeHtml(label)}`;
}

/* ===== Hub State Controller ===== */
// Possible states: 'closed', 'opening', 'open', 'closing'
let _hubState = "closed";

function getHubState() {
  return _hubState;
}

/* ===== Side-switch support ===== */
window.HIST_SHEET_SIDE = "right"; // 'right' or 'left'

function getSheetSide() {
  return window.HIST_SHEET_SIDE === "left" ? "left" : "right";
}

/* ======== Side panel sheet (50vw, left or right) ======== */
function ensureSheet() {
  let sheet = document.getElementById("hist-sheet");
  let content = document.getElementById("historian-container");
  let topbarLayer = document.getElementById("hist-topbar-layer");

  if (!sheet) {
    sheet = document.createElement("div");
    sheet.id = "hist-sheet";

    sheet.style.position = "fixed";
    sheet.style.top = "0";
    sheet.style.bottom = "0";
    sheet.style.width = "70vw"; // middle-half width
    sheet.style.maxWidth = "1400px";
    sheet.style.zIndex = "9998";
    sheet.style.display = "flex";
    sheet.style.flexDirection = "column";
    sheet.style.boxSizing = "border-box";
    sheet.style.pointerEvents = "auto";
    sheet.style.overflow = "hidden";
    sheet.style.transition = "transform 0.3s ease";

    content = document.createElement("div");
    content.id = "historian-container";
    content.className = "historian-container";

    // fill the sheet so nothing gets cut off
    content.style.maxWidth = "100%";
    content.style.width = "100%";
    content.style.height = "100%";
    content.style.margin = "0";
    content.style.boxSizing = "border-box";
    content.style.overflowY = "auto";

    sheet.appendChild(content);
    document.body.appendChild(sheet);
  } else if (content) {
    content.style.maxWidth = "100%";
    content.style.width = "100%";
    content.style.height = "100%";
    content.style.margin = "0";
    content.style.boxSizing = "border-box";
    content.style.overflowY = "auto";
  }

  // Create floating topbar layer OUTSIDE the sheet (attached to body) for true transparency
  if (!topbarLayer) {
    topbarLayer = document.getElementById("hist-topbar-layer");
    if (!topbarLayer) {
      topbarLayer = document.createElement("div");
      topbarLayer.id = "hist-topbar-layer";
      document.body.appendChild(topbarLayer);
    }
  }

  return { sheet, content, topbarLayer };
}

/* Helper to update the floating topbar layer */
function updateTopbarLayer(showBack = false) {
  const { topbarLayer, sheet } = ensureSheet();
  if (!topbarLayer) return;

  const backBtn = showBack
    ? `<button class="hist-back-btn" id="hist-back" title="Back"><i class="fas fa-chevron-left"></i></button>`
    : "";

  topbarLayer.innerHTML = `
    ${backBtn}
    <button class="hist-close-btn" id="hist-close" title="Close"><i class="fas fa-times"></i></button>
  `;

  // Position relative to sheet side
  const side = getSheetSide();
  if (side === "left") {
    topbarLayer.style.left = "auto";
    topbarLayer.style.right = "auto";
    // Position at the right edge of the sheet
    if (sheet) {
      const sheetWidth = sheet.style.width || "70vw";
      topbarLayer.style.left = `calc(${sheetWidth} - 88px)`;
    } else {
      topbarLayer.style.left = "calc(70vw - 88px)";
    }
  } else {
    topbarLayer.style.left = "auto";
    topbarLayer.style.right = "16px";
  }
}

function openSheet() {
  const { sheet, topbarLayer } = ensureSheet();
  const side = getSheetSide();

  sheet.style.removeProperty("height");
  sheet.style.pointerEvents = "";
  sheet.classList.add("hist-open");
  if (topbarLayer) topbarLayer.classList.add("hist-open");
  document.body.classList.add("hist-focus");

  // position + starting transform based on side
  if (side === "right") {
    sheet.style.left = "auto";
    sheet.style.right = "0";
    sheet.style.transform = "translateX(100%)"; // start off-screen right
  } else {
    sheet.style.left = "0";
    sheet.style.right = "auto";
    sheet.style.transform = "translateX(-100%)"; // start off-screen left
  }

  // Mark state as opening
  _hubState = "opening";

  // slide into view
  requestAnimationFrame(() => {
    sheet.style.transform = "translateX(0)";
  });

  // Mark as fully open after animation completes
  const onTransitionEnd = (e) => {
    if (e.propertyName === "transform") {
      _hubState = "open";
      sheet.removeEventListener("transitionend", onTransitionEnd);
    }
  };
  sheet.addEventListener("transitionend", onTransitionEnd);

  // Fallback: if transitionend doesn't fire within 500ms, mark as open anyway
  setTimeout(() => {
    if (_hubState === "opening") {
      _hubState = "open";
    }
  }, 500);
}

function closeSheet() {
  const sheet = document.getElementById("hist-sheet");
  const topbarLayer = document.getElementById("hist-topbar-layer");
  if (!sheet) return;

  const side = getSheetSide();

  // Mark state as closing
  _hubState = "closing";

  document.body.classList.remove("hist-focus");

  sheet.style.pointerEvents = "none";

  // slide back out to the side it came from
  sheet.style.transform =
    side === "right" ? "translateX(100%)" : "translateX(-100%)";

  sheet.classList.remove("hist-open");
  if (topbarLayer) topbarLayer.classList.remove("hist-open");

  // Mark as fully closed after animation completes
  const onTransitionEnd = (e) => {
    if (e.propertyName === "transform") {
      _hubState = "closed";
      sheet.removeEventListener("transitionend", onTransitionEnd);
    }
  };
  sheet.addEventListener("transitionend", onTransitionEnd);

  // Fallback: if transitionend doesn't fire within 500ms, mark as closed anyway
  setTimeout(() => {
    if (_hubState === "closing") {
      _hubState = "closed";
    }
  }, 500);
}

function ensureContainer() {
  return ensureSheet().content;
}
function openFocusUI() {
  // Guard: don't open if already open or in transition
  if (_hubState === "open" || _hubState === "opening") {
    return;
  }
  openSheet();
}
function closeFocusUI() {
  // Guard: don't close if already closed or in transition
  if (_hubState === "closed" || _hubState === "closing") {
    return;
  }
  document.body.classList.remove("lesson-hub-active");
  document.body.classList.remove("lesson-mode-active");
  closeSheet();
  // Clear the active lesson context when closing the hub
  window.activeLessonContext = null;
  window.dispatchEvent(new CustomEvent("historianHubClosed"));
  window.dispatchEvent(new CustomEvent("lessonContextCleared"));
}

/* ===================== Historian App (GLOBAL) ===================== */
window.Historian = {
  state: {
    character: null,
    topics: [],
    subtopicsByTopic: Object.create(null),
    topicTitle: null,
    subtopics: [],
    currentSubIndex: 0,
    lessonText: "",
    // quiz state
    quizzes: [],
    activeQuizIndex: -1,
    quizCollapsed: false,
    // loading guards
    isQuizLoading: false,
    // responsive
    compact: false,
    activePane: "lesson", // 'topics' | 'lesson'
  },

  /* -------------------- Responsive Pane Logic -------------------- */
  applyResponsiveMode() {
    const container = ensureContainer();
    const w = window.innerWidth;
    const compact = w <= 768;

    this.state.compact = compact;
    container.classList.toggle("hist-compact", compact);

    // In compact mode: hide rail, show subtopic dropdown; in wide mode: show rail, hide dropdown
    const rail = container.querySelector(".hist-rail");
    const dropdown = container.querySelector("#hist-subtopic-dropdown");

    if (compact) {
      if (rail) rail.style.display = "none";
      if (dropdown) dropdown.style.display = "block";
    } else {
      if (rail) rail.style.display = "";
      if (dropdown) dropdown.style.display = "none";
    }
  },

  async openHub() {
    const loadedCharacterName = window.bioController?.currentCharacterName;
    if (loadedCharacterName) {
      openFocusUI();
      return this.loadTopics(loadedCharacterName);
    }

    const container = ensureContainer();
    container.classList.remove("hist-lesson");
    container.classList.remove("hist-topics-view");
    container.classList.remove("hist-hide-subtopics");
    openFocusUI();
    updateTopbarLayer(false);
    const closeBtn = document.getElementById("hist-close");
    if (closeBtn) closeBtn.onclick = () => closeFocusUI();
    container.innerHTML = `
      <div class="histCharacter-card">
        <button class="histCharacter-btn" data-character="Richard Feynman">Richard Feynman</button>
        <button class="histCharacter-btn" data-character="Marie Curie">Marie Curie</button>
        <button class="histCharacter-btn" data-character="Niels Bohr">Niels Bohr</button>
        <button class="histCharacter-btn" data-character="Amelia Earhart">Amelia Earhart</button>
        <button class="histCharacter-btn" data-character="Isaac Newton">Isaac Newton</button>
        <button class="histCharacter-btn" data-character="Oppenheimer">Oppenheimer</button>
        <button class="histCharacter-btn" data-character="Alan Turing">Alan Turing</button>
        <button class="histCharacter-btn" data-character="John Neumann">John Neumann</button>
        <button class="histCharacter-btn" data-character="Henry Ford">Henry Ford</button>
        <button class="histCharacter-btn" data-character="René Descartes">René Descartes</button>
        <button class="histCharacter-btn" data-character="Nikola Tesla">Nikola Tesla</button>
        <button class="histCharacter-btn" data-character="Michael Faraday">Michael Faraday</button>

        <button class="histCharacter-btn" data-character="Van Gogh">Van Gogh</button>
        <button class="histCharacter-btn" data-character="Al Capone">Al Capone</button>
        <button class="histCharacter-btn" data-character="Salvador Dali">Salvador Dali</button>
        <button class="histCharacter-btn" data-character="Mansa Musa">Mansa Musa</button>
        <button class="histCharacter-btn" data-character="George Orwell">George Orwell</button>
        <button class="histCharacter-btn" data-character="Confucius">Confucius</button>

        <button class="histCharacter-btn" data-character="Muhammad Ali">Muhammad Ali</button>
        <button class="histCharacter-btn" data-character="Niels Bohr">Niels Bohr</button>
        <button class="histCharacter-btn" data-character="Friedrich Nietzsche">Friedrich Nietzsche</button>
        <button class="histCharacter-btn" data-character="Plato">Plato</button>
        <button class="histCharacter-btn" data-character="Genghis Khan">Genghis Khan</button>
        <button class="histCharacter-btn" data-character="Albert Einstein">Albert Einstein</button>
        <button class="histCharacter-btn" data-character="Leonardo da Vinci">Leonardo da Vinci</button>
        <button class="histCharacter-btn" data-character="Claude Shannon">Claude Shannon</button>
        <button class="histCharacter-btn" data-character="Erwin Schrodinger">Erwin Schrodinger</button>


        <button class="histCharacter-btn" data-character="Napoleon Bonaparte">Napoleon Bonaparte</button>
        <button class="histCharacter-btn" data-character="Abraham Lincoln">Abraham Lincoln</button>
        <button class="histCharacter-btn" data-character="Adam Smith">Adam Smith</button>
        <button class="histCharacter-btn" data-character="Karl Marx">Karl Marx</button>
        <button class="histCharacter-btn" data-character="Enrico Fermi">Enrico Fermi</button>
        <button class="histCharacter-btn" data-character="Niccolo Machiavelli">Niccolo Machiavelli</button>

      </div>
    `;
    container
      .querySelectorAll(".histCharacter-btn[data-character]")
      .forEach((btn) => {
        btn.onclick = () => this.loadTopics(btn.dataset.character);
      });
    this.applyResponsiveMode();
    window.addEventListener("resize", () => this.applyResponsiveMode(), {
      passive: true,
    });
  },

  async loadTopics(character) {
    const container = ensureContainer();
    container.classList.remove("hist-lesson");
    container.classList.remove("hist-hide-subtopics");
    container.classList.add("hist-topics-view");
    showLoading(container, "Finding great topics…");
    this.state.character = character;
    this.state.subtopicsByTopic = Object.create(null);

    const maxRetries = 5;
    let topics = null;
    let lastError = null;

    for (let attempt = 1; attempt <= maxRetries; attempt++) {
      try {
        topics = await API("/api/topics", "POST", {
          character,
          sessionId: HIST_SESSION_ID,
        });
        if (topics && Array.isArray(topics) && topics.length > 0) {
          break;
        }
        lastError = new Error("Topics not available or empty response");
      } catch (e) {
        lastError = e;
        console.warn(
          `Topic request attempt ${attempt}/${maxRetries} failed:`,
          e,
        );
      }
      if (attempt < maxRetries) {
        showLoading(
          container,
          `Retrying… (attempt ${attempt + 1}/${maxRetries})`,
        );
        await new Promise((resolve) => setTimeout(resolve, 1000));
      }
    }

    if (!topics || !Array.isArray(topics) || topics.length === 0) {
      container.innerHTML = `<div class="hist-card">Failed to load topics after ${maxRetries} attempts. Please try again.</div>`;
      console.error("All topic request attempts failed:", lastError);
      return;
    }

    try {
      this.state.topics = topics;

      updateTopbarLayer(true);
      const backBtn1 = document.getElementById("hist-back");
      const closeBtn1 = document.getElementById("hist-close");
      if (backBtn1) backBtn1.onclick = () => this.openHub();
      if (closeBtn1) closeBtn1.onclick = () => closeFocusUI();

      container.innerHTML = `
        <p class="hist-muted">Pick any subtopic under the topics below to jump right in:</p>
        <div id="topic-stack">
          ${topics
            .map(
              (t, i) => `
            <div class="hist-card" data-topic-idx="${i}">
              <h3 class="hist-item-title">${escapeHtml(t.title)}</h3>
              <p class="hist-muted">${escapeHtml(t.desc || "")}</p>
              <div class="hist-muted" id="sub-loading-${i}">Loading subtopics…</div>
              <div class="subtopic-list" id="sub-list-${i}" style="display:none;"></div>
            </div>
          `,
            )
            .join("")}
        </div>
      `;

      topics.forEach(async (t, i) => {
        try {
          const subs = await this.getSubtopics(t.title, this.state.character);
          const holder = container.querySelector(`#sub-list-${i}`);
          const loading = container.querySelector(`#sub-loading-${i}`);
          if (loading) loading.remove();
          if (holder) {
            holder.style.display = "block";
            holder.innerHTML = `
              <div class="hist-rail" style="position:relative; top:0;">
                ${subs
                  .map(
                    (s, idx) => `
                  <div class="rail-item" data-topic="${escapeHtml(t.title)}" data-idx="${idx}">
                    <span>${escapeHtml(s.title)}</span>
                  </div>`,
                  )
                  .join("")}
              </div>
            `;
            holder.querySelectorAll(".rail-item").forEach((el) => {
              el.addEventListener("click", () => {
                const topicTitle = el.getAttribute("data-topic");
                const idx = parseInt(el.getAttribute("data-idx"), 10);
                this.state.topicTitle = topicTitle;
                this.state.subtopics =
                  this.state.subtopicsByTopic[topicTitle] || [];
                this.loadLesson(idx);
              });
            });
          }
        } catch (e) {
          const loading = container.querySelector(`#sub-loading-${i}`);
          if (loading)
            loading.innerHTML = `<span class="hist-muted">Failed to load subtopics.</span>`;
          console.error(e);
        }
      });

      this.applyResponsiveMode();
    } catch (e) {
      container.innerHTML = `<div class="hist-card">Failed to load topics. Please try again.</div>`;
      console.error(e);
    }
  },

  async getSubtopics(topicTitle, character) {
    if (this.state.subtopicsByTopic[topicTitle])
      return this.state.subtopicsByTopic[topicTitle];
    const subs = await API("/api/topics/generate-subtopics", "POST", {
      topicTitle,
      character,
      sessionId: HIST_SESSION_ID,
    });
    this.state.subtopicsByTopic[topicTitle] = subs;
    return subs;
  },

  renderMediaElement(m) {
    const kind = (m.type || "").toLowerCase();
    const cap = escapeHtml(m.caption || "");
    if (kind === "video" && m.src) {
      const src = normalizeToEmbed(m.src);
      const isYouTube = /youtube\.com\/embed|youtu\.be\//.test(src);
      return isYouTube
        ? `<figure class="inline-media-embed">
             <iframe class="hist-iframe" src="${escapeHtml(src)}" title="${cap || "Video"}"
               allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
               referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
             ${cap ? `<figcaption>${cap}</figcaption>` : ""}
           </figure>`
        : `<figure class="inline-media-embed">
             <video controls preload="metadata" src="${escapeHtml(src)}"></video>
             ${cap ? `<figcaption>${cap}</figcaption>` : ""}
           </figure>`;
    }
    if (kind === "image" && m.src) {
      return `<figure class="inline-media-embed">
              <img alt="${cap || "related image"}" loading="lazy" src="${escapeHtml(m.src)}"/>
              ${cap ? `<figcaption>${cap}</figcaption>` : ""}
            </figure>`;
    }
    return "";
  },

  renderLessonWithInlineMedia(renderedHtml, media) {
    if (!media || media.length === 0) return renderedHtml;

    const mediaByIndex = {};
    media.forEach((m) => {
      if (typeof m.index === "number") {
        mediaByIndex[m.index] = m;
      }
    });

    let result = renderedHtml;
    const usedIndices = new Set();

    const pWrappedMarkerRegex = /<p>\s*\[MEDIA:(\d+)\]\s*<\/p>/g;
    result = result.replace(pWrappedMarkerRegex, (match, indexStr) => {
      const idx = parseInt(indexStr, 10);
      const mediaItem = mediaByIndex[idx];
      if (mediaItem) {
        usedIndices.add(idx);
        return this.renderMediaElement(mediaItem);
      }
      return "";
    });

    const standaloneMarkerRegex = /\[MEDIA:(\d+)\]/g;
    result = result.replace(standaloneMarkerRegex, (match, indexStr) => {
      const idx = parseInt(indexStr, 10);
      if (usedIndices.has(idx)) return "";
      const mediaItem = mediaByIndex[idx];
      if (mediaItem) {
        usedIndices.add(idx);
        return this.renderMediaElement(mediaItem);
      }
      return "";
    });

    const unusedMedia = media.filter((item) => !usedIndices.has(item.index));

    if (unusedMedia.length > 0) {
      const remainingMediaHtml = `
        <div class="inline-media-section">
          <h3>Related Media</h3>
          <div class="inline-media-grid">
            ${unusedMedia.map((m) => this.renderMediaElement(m)).join("")}
          </div>
        </div>
      `;
      result += remainingMediaHtml;
    }

    return result;
  },

  async loadLesson(index) {
    const container = ensureContainer();
    container.classList.remove("hist-topics-view");
    container.classList.add("hist-lesson");
    container.classList.add("hist-hide-subtopics");
    showLoading(container, "Preparing lesson…");
    this.state.currentSubIndex = index;
    const sub = this.state.subtopics[index];

    try {
      const res = await API("/api/lesson", "POST", {
        topicTitle: this.state.topicTitle,
        subtopicTitle: sub.title,
        character: this.state.character,
        sessionId: HIST_SESSION_ID,
      });
      this.state.lessonText = res.text || "";
      const media = Array.isArray(res.media) ? res.media : [];
      const rendered = await window.renderMarkdownAsync(this.state.lessonText);

      // Set global lesson context for chat integration
      window.activeLessonContext = {
        character: this.state.character,
        topicTitle: this.state.topicTitle,
        subtopicTitle: sub.title,
        lessonContent: this.state.lessonText,
      };
      window.dispatchEvent(
        new CustomEvent("lessonContextUpdated", {
          detail: window.activeLessonContext,
        }),
      );
      console.log(
        "[Historian] Active lesson context set:",
        window.activeLessonContext.subtopicTitle,
      );

      const lessonWithMedia = this.renderLessonWithInlineMedia(rendered, media);

      // Build subtopic dropdown for compact mode
      const subtopicDropdownHtml = `
        <div id="hist-subtopic-dropdown" class="hist-subtopic-dropdown" style="display: none;">
          <label for="subtopic-select" class="hist-muted">${escapeHtml(this.state.character)} - ${escapeHtml(this.state.topicTitle)}</label>
          <select id="subtopic-select" class="hist-select">
            ${this.state.subtopics
              .map(
                (s, i) =>
                  `<option value="${i}" ${i === index ? "selected" : ""}>${escapeHtml(s.title)}</option>`,
              )
              .join("")}
          </select>
        </div>
      `;

      updateTopbarLayer(true);
      const backBtn2 = document.getElementById("hist-back");
      const closeBtn2 = document.getElementById("hist-close");
      if (backBtn2)
        backBtn2.onclick = () => this.loadTopics(this.state.character);
      if (closeBtn2) closeBtn2.onclick = () => closeFocusUI();

      container.innerHTML = `
        ${subtopicDropdownHtml}

        <div class="hist-grid hist-grid--wide" id="lesson-grid">
          <aside class="hist-rail">
            <h4>${escapeHtml(this.state.character)}</h4>
            <div class="hist-muted" style="margin-bottom:10px;">${escapeHtml(this.state.topicTitle)}</div>
            <div id="rail-items">
              ${this.state.subtopics
                .map(
                  (s, i) => `
                <div class="rail-item ${i === index ? "active" : ""}" data-idx="${i}">
                  <span>${escapeHtml(s.title)}</span>
                  ${i === index ? "<span>•</span>" : ""}
                </div>`,
                )
                .join("")}
            </div>
          </aside>

          <section class="content-col">
            <article id="hist-lesson-article" class="hist-card">
              <h2 class="hist-heading-with-btn">
                <span class="hist-heading-text">${escapeHtml(sub.title)}</span>
                <button class="btn-teach-me btn-teach-me-lg" id="hist-teach-me-btn">
                  <i class="fas fa-chalkboard-teacher"></i> Teach Me
                </button>
              </h2>
              <div id="hist-teach-me-response"></div>
              <div class="hist-lesson-content">${lessonWithMedia}</div>
            </article>

            <div class="hist-card" id="quiz-card">
              <div class="hist-row">
                <h3 class="hist-title" style="margin:0;">Test Your Knowledge</h3>
                <div class="quiz-controls">
                  <button class="hist-ghost" id="quiz-toggle" title="Expand/Collapse">▾</button>
                  <button class="hist-btn" id="quiz-new">New Quiz</button>
                </div>
              </div>

              <div id="quiz-section">
                <div class="quiz-toolbar">
                  <button class="hist-ghost" id="quiz-prev" title="Previous Quiz">⟨</button>
                  <div id="quiz-list" class="quiz-list"></div>
                  <button class="hist-ghost" id="quiz-next" title="Next Quiz">⟩</button>
                </div>

                <div id="quiz-zone" style="margin-top:12px;"></div>
                <div id="quiz-feedback" style="margin-top:10px;"></div>
              </div>
            </div>
          </section>
        </div>
      `;

      // left rail navigation (wide mode)
      container.querySelectorAll(".rail-item").forEach((el) => {
        el.addEventListener("click", () => {
          const idx = parseInt(el.dataset.idx, 10);
          if (idx !== this.state.currentSubIndex) {
            this.loadLesson(idx);
          }
        });
      });

      // Subtopic dropdown navigation (compact mode)
      const subtopicSelect = document.getElementById("subtopic-select");
      if (subtopicSelect) {
        subtopicSelect.addEventListener("change", (e) => {
          const idx = parseInt(e.target.value, 10);
          if (idx !== this.state.currentSubIndex) {
            this.loadLesson(idx);
          }
        });
      }

      // --- QUIZ UI wiring ---
      const quizToggleBtn = document.getElementById("quiz-toggle");
      const quizSection = document.getElementById("quiz-section");
      if (quizToggleBtn && quizSection) {
        quizToggleBtn.onclick = () => {
          this.state.quizCollapsed = !this.state.quizCollapsed;
          quizSection.style.display = this.state.quizCollapsed
            ? "none"
            : "block";
          quizToggleBtn.textContent = this.state.quizCollapsed ? "▸" : "▾";
        };
      }

      // Seed first quiz from lesson content
      await this.loadQuizFromLesson(sub);

      // New Quiz button
      const newBtn = document.getElementById("quiz-new");
      if (newBtn)
        newBtn.onclick = () => generateQuizFromStoredChatThrottled(newBtn);

      // Navigation
      const quizPrev = document.getElementById("quiz-prev");
      const quizNext = document.getElementById("quiz-next");
      if (quizPrev) quizPrev.onclick = () => this.moveQuiz(-1);
      if (quizNext) quizNext.onclick = () => this.moveQuiz(1);

      // Teach Me button handler
      const teachMeBtn = document.getElementById("hist-teach-me-btn");
      if (teachMeBtn) {
        teachMeBtn.onclick = () => this.handleTeachMe();
      }

      // responsive tabs
      this.applyResponsiveMode();
    } catch (e) {
      const msg = (e && e.message) || "Failed to load lesson.";
      container.innerHTML = `<div class="hist-card">${escapeHtml(msg)} Please try again.</div>`;
      console.error(e);
    }
  },

  /* -------------------- TEACH ME: lesson audio explanation -------------------- */
  async handleTeachMe() {
    const responseContainer = document.getElementById("hist-teach-me-response");
    const teachMeBtn = document.getElementById("hist-teach-me-btn");

    if (!responseContainer) return;

    // Get current lesson content
    const lessonContent = this.state.lessonText;
    const character = this.state.character;
    const topicTitle = this.state.topicTitle;
    const sub = this.state.subtopics[this.state.currentSubIndex];
    const subtopicTitle = sub?.title || "";

    if (!lessonContent) {
      responseContainer.innerHTML = `
        <div class="teach-me-response" style="border-color: rgba(239, 68, 68, 0.3); background: rgba(239, 68, 68, 0.08);">
          <p style="color: #ef4444;">No lesson content available to teach.</p>
        </div>
      `;
      return;
    }

    // Disable button and show loading
    if (teachMeBtn) {
      teachMeBtn.disabled = true;
    }

    responseContainer.innerHTML = `
      <div class="teach-me-loading">
        <div class="spinner-border spinner-border-sm text-info" role="status"></div>
        <span>Getting teaching explanation with audio...</span>
      </div>
    `;

    const chatController = window.chatController;

    // Ensure TTS is initialized - call initializeStreamingTTS if realtimeTTS doesn't exist yet
    let realtimeTTS = chatController?.realtimeTTS;
    if (
      !realtimeTTS &&
      chatController &&
      typeof chatController.initializeStreamingTTS === "function"
    ) {
      console.log("[Historian TeachMe] TTS not ready, initializing...");
      try {
        realtimeTTS = await chatController.initializeStreamingTTS();
      } catch (e) {
        console.warn("[Historian TeachMe] TTS initialization failed:", e);
      }
    }

    // Show chat container if available
    if (chatController && chatController.chatContainer) {
      chatController.chatContainer.classList.add("visible");
    }

    const xhr = new XMLHttpRequest();
    xhr.open("POST", "/api/teach-me/stream", true);
    xhr.setRequestHeader("Content-Type", "application/json");
    xhr.setRequestHeader("Cache-Control", "no-cache");

    let lastProcessedLength = 0;
    let processingBuffer = "";
    let streamingContent = "";
    let streamingStarted = false;
    let currentStreamingMessage = null;

    // Add message to chat if available
    if (
      chatController &&
      typeof chatController.addMessageToChat === "function"
    ) {
      currentStreamingMessage = chatController.addMessageToChat(
        "",
        "",
        "bot-message",
      );
    }

    // Prepare TTS for streaming
    if (realtimeTTS) {
      try {
        if (typeof realtimeTTS.ensureReadyForNextResponse === "function") {
          await realtimeTTS.ensureReadyForNextResponse(120);
        }
        if (realtimeTTS.audioCtx && realtimeTTS.audioCtx.state !== "running") {
          await realtimeTTS.audioCtx.resume();
        }
        console.log("[Historian TeachMe] TTS ready for streaming");
        // Clear stop guard so deltas are not silently dropped
        if (typeof realtimeTTS.clearStopGuard === "function") {
          realtimeTTS.clearStopGuard();
        }
      } catch (e) {
        console.warn("[Historian TeachMe] TTS prep failed (continuing)", e);
      }
    } else {
      console.warn(
        "[Historian TeachMe] No TTS available - audio will be disabled",
      );
    }

    xhr.onreadystatechange = () => {
      if (xhr.readyState >= 3) {
        const fullResponse = xhr.responseText;
        const newData = fullResponse.substring(lastProcessedLength);
        lastProcessedLength = fullResponse.length;

        if (newData) {
          processingBuffer += newData;

          let startPos = 0;
          let newlinePos = processingBuffer.indexOf("\n", startPos);

          while (newlinePos !== -1) {
            const line = processingBuffer.substring(startPos, newlinePos);

            if (line.startsWith("data: ")) {
              try {
                const data = JSON.parse(line.slice(6));

                if (data.type === "metadata") {
                  // TTS is already prepared via ensureReadyForNextResponse
                  // Just mark streaming as started so we can begin sending chunks
                  if (realtimeTTS && !streamingStarted) {
                    streamingStarted = true;
                    console.log(
                      "[Historian TeachMe] Metadata received, TTS streaming ready",
                    );
                  }
                } else if (data.type === "chunk") {
                  streamingContent += data.content;

                  if (realtimeTTS && streamingStarted) {
                    try {
                      realtimeTTS.handleLLMDelta(data.content);
                    } catch (err) {
                      console.warn("[Historian TeachMe] TTS delta error:", err);
                    }
                  }

                  // Update chat message
                  if (currentStreamingMessage) {
                    const messageContent =
                      currentStreamingMessage.querySelector(".message-content");
                    if (messageContent) {
                      messageContent.innerHTML = streamingContent.replace(
                        /\n/g,
                        "<br>",
                      );
                      if (chatController.chatHistory) {
                        chatController.chatHistory.scrollTop =
                          chatController.chatHistory.scrollHeight;
                      }
                    }
                  }
                } else if (data.type === "complete") {
                  if (realtimeTTS && streamingStarted) {
                    try {
                      realtimeTTS.flushAndClose();
                      console.log(
                        "[Historian TeachMe] Realtime TTS flushed and closed",
                      );
                    } catch (err) {
                      console.warn("[Historian TeachMe] TTS close error:", err);
                    }
                  }

                  responseContainer.innerHTML = `
                    <div class="teach-me-response">
                      <div class="teach-me-response-header">
                        <i class="fas fa-chalkboard-teacher"></i>
                        <span>Teaching Explanation</span>
                      </div>
                      <div>${(data.complete_response || streamingContent).replace(/\n/g, "<br>")}</div>
                    </div>
                  `;

                  if (
                    chatController &&
                    typeof chatController.addToConversationHistory ===
                      "function"
                  ) {
                    chatController.addToConversationHistory(
                      "assistant",
                      data.complete_response || streamingContent,
                    );
                  }

                  if (teachMeBtn) {
                    teachMeBtn.disabled = false;
                  }
                } else if (data.type === "error") {
                  responseContainer.innerHTML = `
                    <div class="teach-me-response" style="border-color: rgba(239, 68, 68, 0.3); background: rgba(239, 68, 68, 0.08);">
                      <div style="color: #ef4444;">
                        <i class="fas fa-exclamation-circle"></i> ${escapeHtml(data.error || "Failed to get explanation.")}
                      </div>
                    </div>
                  `;

                  if (teachMeBtn) {
                    teachMeBtn.disabled = false;
                  }
                }
              } catch (parseError) {
                console.warn("[Historian TeachMe] Parse error:", parseError);
              }
            }

            startPos = newlinePos + 1;
            newlinePos = processingBuffer.indexOf("\n", startPos);
          }

          processingBuffer = processingBuffer.substring(startPos);
        }
      }
    };

    xhr.onerror = () => {
      responseContainer.innerHTML = `
        <div class="teach-me-response" style="border-color: rgba(239, 68, 68, 0.3); background: rgba(239, 68, 68, 0.08);">
          <div style="color: #ef4444;">
            <i class="fas fa-exclamation-circle"></i> Network error. Please try again.
          </div>
        </div>
      `;

      if (teachMeBtn) {
        teachMeBtn.disabled = false;
      }
    };

    xhr.send(
      JSON.stringify({
        segment_content: lessonContent,
        segment_type: "lesson",
        topic: topicTitle,
        subtopic: subtopicTitle,
        character: character,
      }),
    );
  },

  /* -------------------- QUIZ: core helpers -------------------- */
  // Coerce the active quiz's questions to MCQ shape (choices array + prompt).
  getActiveQuestions() {
    const i = this.state.activeQuizIndex;
    if (i < 0 || !this.state.quizzes || !this.state.quizzes.length) return [];
    const quiz = this.state.quizzes[i];
    const qs = (quiz && quiz.questions) || [];
    return qs.map((q) => {
      if (q.type !== "mcq") {
        const ans =
          typeof q.answer === "string"
            ? q.answer
            : q.answer === true
              ? "True"
              : "False";
        const choices =
          Array.isArray(q.choices) && q.choices.length
            ? q.choices
            : [String(ans), "Not sure", "Maybe", "Incorrect"];
        return { ...q, type: "mcq", choices };
      }
      return q;
    });
  },

  // Resolve which choice index is the correct answer for a question.
  correctIndexFor(q) {
    const choices = (q.choices || []).map((c) => String(c));
    const norm = (s) => String(s).trim().toLowerCase().replace(/\s+/g, " ");
    const ans = q.answer;
    if (typeof ans === "boolean") {
      const want = ans ? "true" : "false";
      return choices.findIndex((c) => norm(c) === want);
    }
    const s = String(ans ?? "").trim();
    if (/^[A-Za-z]$/.test(s)) {
      const i = s.toUpperCase().charCodeAt(0) - 65;
      if (i >= 0 && i < choices.length) return i;
    }
    if (/^\d+$/.test(s)) {
      const i = parseInt(s, 10) - 1;
      if (i >= 0 && i < choices.length) return i;
    }
    const target = norm(s);
    return choices.findIndex((c) => norm(c) === target);
  },

  // Progress dots — one per question in the active quiz (mockup styling).
  renderQuizList() {
    const list = document.getElementById("quiz-list");
    if (!list) return;
    this.state.quizProgress = this.state.quizProgress || [];

    const qs = this.getActiveQuestions();
    const n = qs.length;
    if (!n) {
      list.innerHTML = "";
      return;
    }

    list.innerHTML = Array.from({ length: n }, (_, i) => {
      let cls = "quiz-list-dot";
      const p = this.state.quizProgress[i];
      if (p) cls += p.correct ? " is-correct" : " is-wrong";
      if (i === this.state.activeQuestionIndex) cls += " is-current";
      return `<span class="${cls}"></span>`;
    }).join("");
  },

  // Navigate between questions of the active quiz.
  moveQuiz(dir) {
    const qs = this.getActiveQuestions();
    const n = qs.length;
    if (!n) return;
    this.state.activeQuestionIndex =
      ((this.state.activeQuestionIndex || 0) + dir + n) % n;
    this.renderQuizList();
    this.renderActiveQuiz();
  },

  // Render the current question as Tuscan-dusk option buttons (A/B/C/D pills).
  renderActiveQuiz() {
    const zone = document.getElementById("quiz-zone");
    const fb = document.getElementById("quiz-feedback");
    if (!zone) return;
    this.state.quizProgress = this.state.quizProgress || [];
    if (typeof this.state.activeQuestionIndex !== "number")
      this.state.activeQuestionIndex = 0;
    if (fb) {
      fb.innerHTML = "";
      fb.className = "quiz-feedback";
    }

    const qs = this.getActiveQuestions();
    if (!qs.length) {
      zone.innerHTML = `<p class="quiz-q-text hist-muted">No quiz yet — press "New Quiz" to generate one.</p>`;
      return;
    }

    const qi = Math.min(this.state.activeQuestionIndex, qs.length - 1);
    this.state.activeQuestionIndex = qi;
    const q = qs[qi];
    const choices = q.choices || [];
    const correctIdx = this.correctIndexFor(q);
    const letters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";

    zone.innerHTML = `
      <p class="quiz-q-text">${escapeHtml(q.prompt || `Question ${qi + 1}`)}</p>
      <div class="quiz-options">
        ${choices
          .map(
            (c, ci) => `
          <button class="quiz-option" type="button" data-ci="${ci}" data-correct="${ci === correctIdx ? "true" : "false"}">
            <span class="quiz-option-letter">${letters[ci] || ci + 1}.</span>
            <span>${escapeHtml(String(c))}</span>
          </button>`,
          )
          .join("")}
      </div>
    `;

    zone.querySelectorAll(".quiz-option").forEach((btn) => {
      btn.onclick = () =>
        this.answerQuestion(qi, parseInt(btn.dataset.ci, 10), correctIdx, q);
    });

    const prior = this.state.quizProgress[qi];
    if (prior) this.applyAnswerUI(prior.chosen, correctIdx, q);
  },

  // Record an answer and reveal correct/incorrect feedback.
  answerQuestion(qi, chosen, correctIdx, q) {
    this.state.quizProgress = this.state.quizProgress || [];
    if (this.state.quizProgress[qi]) return; // already answered
    const correct = chosen === correctIdx;
    this.state.quizProgress[qi] = { chosen, correct };
    this.applyAnswerUI(chosen, correctIdx, q);
    this.renderQuizList();
  },

  // Paint option buttons + feedback box for an answered question.
  applyAnswerUI(chosen, correctIdx, q) {
    const zone = document.getElementById("quiz-zone");
    const fb = document.getElementById("quiz-feedback");
    if (!zone) return;
    zone.querySelectorAll(".quiz-option").forEach((btn) => {
      const ci = parseInt(btn.dataset.ci, 10);
      btn.disabled = true;
      btn.classList.remove("is-selected", "is-correct", "is-wrong");
      if (ci === correctIdx) btn.classList.add("is-correct");
      else if (ci === chosen) btn.classList.add("is-wrong");
      if (ci === chosen) btn.classList.add("is-selected");
    });

    const correct = chosen === correctIdx;
    if (fb) {
      const rationale = q && q.rationale ? escapeHtml(q.rationale) : "";
      fb.className =
        "quiz-feedback is-visible " + (correct ? "is-correct" : "is-wrong");
      fb.innerHTML =
        (correct ? "Correct." : "Not quite.") +
        (rationale ? " " + rationale : "");
    }
  },

  // Seed from lesson (legacy)
  async loadQuizFromLesson(sub) {
    try {
      const res = await API("/api/quiz", "POST", {
        topicTitle: this.state.topicTitle,
        subtopicTitle: sub.title,
        character: this.state.character,
        sessionId: HIST_SESSION_ID,
      });
      const questions = (res.quiz && res.quiz.questions) || [];
      const item = { id: `lesson-${Date.now()}`, title: "1", questions };
      this.state.quizzes = [item];
      this.state.activeQuizIndex = 0;
      this.state.activeQuestionIndex = 0;
      this.state.quizProgress = [];
      this.renderQuizList();
      this.renderActiveQuiz();
      if (HIST_DEBUG) console.info("[quiz source] lesson");
    } catch (e) {
      console.error(e);
      this.state.quizzes = [];
      this.state.activeQuizIndex = -1;
      this.state.activeQuestionIndex = 0;
      this.state.quizProgress = [];
      this.renderQuizList();
      this.renderActiveQuiz();
    }
  },
};

// Expose closeFocusUI to allow external toggle (e.g., from Lesson Hub button)
window.Historian.closeFocusUI = closeFocusUI;

// ===== Global Lesson Hub helpers =====

// Open the Lesson Hub in a safe, consistent way
window.openLessonHub = function () {
  try {
    // Use the internal getHubState function (defined in this module)
    const state = getHubState();
    console.log("[LessonHub] openLessonHub called. Current hub state:", state);

    // Avoid double-open
    if (state === "open" || state === "opening") {
      console.log("[LessonHub] Hub already open or opening.");
      return;
    }

    // Mark body as active so your CSS can shift layout
    document.body.classList.add("lesson-hub-active");

    // On desktop, also add lesson-mode-active for left-side layout
    const isDesktop = window.innerWidth >= 769;
    if (isDesktop) {
      document.body.classList.add("lesson-mode-active");
    }

    if (window.Historian && typeof window.Historian.openHub === "function") {
      window.Historian.openHub();
    } else {
      console.warn("[LessonHub] Historian.openHub is not ready on window.");
    }
  } catch (e) {
    console.error("[LessonHub] Error in openLessonHub:", e);
  }
};

// Close the Lesson Hub everywhere
window.closeLessonHub = function () {
  try {
    console.log("[LessonHub] closeLessonHub called");
    // Always remove the body classes for cleanup
    document.body.classList.remove("lesson-hub-active");
    document.body.classList.remove("lesson-mode-active");

    if (
      window.Historian &&
      typeof window.Historian.closeFocusUI === "function"
    ) {
      window.Historian.closeFocusUI();
    }
  } catch (e) {
    console.error("[LessonHub] Error in closeLessonHub:", e);
  }
};

// Toggle the Lesson Hub (open if closed, close if open)
window.toggleLessonHub = function () {
  try {
    const state = getHubState();
    const isActive = document.body.classList.contains("lesson-hub-active");
    console.log(
      "[LessonHub] toggleLessonHub called. Hub state:",
      state,
      "body active:",
      isActive,
    );

    // If open or opening, close it
    if (state === "open" || state === "opening" || isActive) {
      window.closeLessonHub();
    } else {
      window.openLessonHub();
    }
  } catch (e) {
    console.error("[LessonHub] Error in toggleLessonHub:", e);
  }
};

/* ============= New Quiz generation (throttled) ============= */
function getMainChatHistory() {
  try {
    if (
      window.chatController &&
      typeof window.chatController.getConversationHistory === "function"
    ) {
      const history = window.chatController.getConversationHistory();
      if (Array.isArray(history) && history.length > 0) {
        return history.map((m) => ({
          role: m.role || "user",
          content: m.content || "",
        }));
      }
    }
  } catch (e) {
    console.warn("[quiz] Could not retrieve main chat history:", e);
  }
  return [];
}

async function generateQuizFromStoredChatThrottled(buttonEl) {
  const fb = document.getElementById("quiz-feedback");
  if (!buttonEl) return;
  if (window.Historian.state.isQuizLoading) return;

  // lock button
  window.Historian.state.isQuizLoading = true;
  const originalHTML = buttonEl.innerHTML;
  buttonEl.disabled = true;
  buttonEl.innerHTML = buttonSpinner("Generating…");

  // Collect main chat history for richer quiz context
  const mainChatHistory = getMainChatHistory();
  if (HIST_DEBUG && mainChatHistory.length) {
    console.info(
      "[quiz] Including main chat history:",
      mainChatHistory.length,
      "messages",
    );
  }

  let res = null,
    errA = null,
    errB = null,
    source = "lesson";
  try {
    res = await API("/api/quiz", "POST", {
      character: window.Historian.state.character,
      topicTitle: window.Historian.state.topicTitle,
      subtopicTitle:
        (
          window.Historian.state.subtopics[
            window.Historian.state.currentSubIndex
          ] || {}
        ).title || "",
      count: 5,
      sessionId: HIST_SESSION_ID,
      mainChatHistory: mainChatHistory,
    });
    if (HIST_DEBUG && res && res.meta)
      console.info("[quiz] via /api/quiz", res.meta);
  } catch (e) {
    errA = e;
  }

  if (!res || !res.quiz || !(res.quiz.questions || []).length) {
    try {
      res = await API("/api/quiz/from-chat", "POST", {
        character: window.Historian.state.character,
        topicTitle: window.Historian.state.topicTitle,
        subtopicTitle:
          (
            window.Historian.state.subtopics[
              window.Historian.state.currentSubIndex
            ] || {}
          ).title || "",
        count: 5,
        sessionId: HIST_SESSION_ID,
        mainChatHistory: mainChatHistory,
      });
      source = "chat_history";
      if (HIST_DEBUG && res && res.meta)
        console.info("[quiz] via /api/quiz/from-chat", res.meta);
    } catch (e) {
      errB = e;
    }
  }

  const questions = (res && res.quiz && res.quiz.questions) || [];
  if (!questions.length) {
    const extra =
      res && res.error
        ? ` (${String(res.error)})`
        : errA
          ? ` (${String(errA.message || errA)})`
          : errB
            ? ` (${String(errB.message || errB)})`
            : "";
    if (fb)
      fb.innerHTML = `<div class="hist-bubble assistant">Please ask a question and learn, then press New Quiz</div>`;
  } else {
    const nextNumber = window.Historian.state.quizzes.length + 1;
    const item = {
      id: `quiz-${Date.now()}`,
      title: String(nextNumber),
      questions,
    };
    window.Historian.state.quizzes.push(item);
    window.Historian.state.activeQuizIndex =
      window.Historian.state.quizzes.length - 1;
    window.Historian.state.activeQuestionIndex = 0;
    window.Historian.state.quizProgress = [];
    window.Historian.renderQuizList();
    window.Historian.renderActiveQuiz();
    if (fb)
      fb.innerHTML = `<div class="hist-bubble assistant">New quiz ready</div>`;
    if (HIST_DEBUG) console.info("[quiz source]", source);
  }

  // unlock button
  buttonEl.innerHTML = originalHTML;
  buttonEl.disabled = false;
  window.Historian.state.isQuizLoading = false;
}

/* ===========================================================
   END JS – 2-column Lesson UI (Navigation | Main Content)
   =========================================================== */
